export function StepProgress({ step, totalSteps }) {
  return (
    <div className="w-full px-8 mt-4 mb-4">
      <div className="flex gap-2">
        {Array.from({ length: totalSteps }).map((_, index) => {
          const isActive = index < step;

          return (
            <div
              key={index}
              className={`
                flex-1 h-1 rounded-full transition-all duration-500
                ${isActive ? "bg-[#0A4730]" : "bg-gray-100"}
              `}
            />
          );
        })}
      </div>
      <p className="text-[10px] font-bold text-gray-400 mt-2 uppercase tracking-widest">
        Progress: {Math.round((step / totalSteps) * 100)}%
      </p>
    </div>
  );
}
